import Index from "./pages/Index";

function App() {
  return (
    <div className="App">
      <Index/>
    </div>
  );
}

export default App;
